import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private data: DataService, private router: Router) { }

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.data.loggedIn) {
        resolve(true);
      } else {
        this.data.login(true)
        .then(() => {
          resolve(true);
        })
        .catch((err) => {
          this.router.navigateByUrl('/login');
          resolve(false);
        });
      }
    });
  }
}
